export { Spinner, type SpinnerProps } from "./ui";
